import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { teamActions, teamSelectors } from '../../../store/modules/team';
import TeamActionBlock from '../TeamActionBlock';

export type CreateTeamProps = {};

const CreateTeam: FC<CreateTeamProps> = () => {
  const dispatch = useDispatch();
  const isPending = useSelector(teamSelectors.selectTeamCreatePending);

  const create = () => dispatch(teamActions.createTeam());

  return (
    <TeamActionBlock
      title="Create team account"
      description="This will create your team account."
      actionName="Create Account"
      isPending={isPending}
      buttonVariant="light-blue"
      onClick={create}
    />
  );
};

export default CreateTeam;
